import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends RestCallService {

  constructor(
    public httpClient: HttpClient,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService
  ) {
    super(httpClient, 'LockerLinkApi', toastr, notificationService, translate);
  }

  public GetEmployeeByEmail(email: string) {
    return this.post<any>('/api/Employees/GetEmployeeByEmail', { email: email });
  }
}